const RSVP_PHONE_COLLECT_EXPERIMENT = 'test_rsvp-phone-number-collect';

export const isInRsvpPhoneNumberCollectControl = ({readOnly}: {readOnly: boolean}) =>
  evite.experiments.inVariation(RSVP_PHONE_COLLECT_EXPERIMENT, 'control', true, readOnly);
